/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyRecommendationSourceQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicyRecommendationSourceQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicyRecommendationSourceQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicyRecommendationSourceQueryOperator>): PolicyRecommendationSourceQueryOperator {
        let obj = Object.assign(new PolicyRecommendationSourceQueryOperator(), model);
        PolicyRecommendationSourceQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyRecommendationSourceQueryOperator>): PolicyRecommendationSourceQueryOperator {
        if (!model) return null;
        return PolicyRecommendationSourceQueryOperator.newInstance(<PolicyRecommendationSourceQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyRecommendationSourceQueryOperator) {
        if (!obj) return;

        models.PolicyRecommendationSourceQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyRecommendationSourceQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyRecommendationSourceQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Recommendation sources to include
     */
    sources: Array<models.RecommendationSource>;

}
